import { defineMessages } from 'react-intl'

import { VEHICLE_COMPONENT } from 'features/VehicleTemplates/components/Components/constants'
import { SEAT_PROPERTIES, WC_PROPERTIES } from './constants'

export const seatPropertiesMessages = defineMessages({
  [SEAT_PROPERTIES.TV]: {
    id: 'dictionary.tv',
    defaultMessage: 'TV'
  },
  [SEAT_PROPERTIES.PLUG]: {
    id: 'dictionary.plug',
    defaultMessage: 'Plug'
  },
  [SEAT_PROPERTIES.WOMEN]: {
    id: 'dictionary.driver',
    defaultMessage: 'Women seat'
  }
})

export const wcPropertiesMessages = defineMessages({
  [WC_PROPERTIES.MEN]: {
    id: 'dictionary.men',
    defaultMessage: 'Men'
  },
  [WC_PROPERTIES.WOMEN]: {
    id: 'dictionary.women',
    defaultMessage: 'Women'
  }
})

export const getPropertyMessage = (component: TSFixMe, property: TSFixMe): TSFixMe => {
  switch (component) {
    case VEHICLE_COMPONENT.SEAT:
      return seatPropertiesMessages[property]
    case VEHICLE_COMPONENT.WC:
      return wcPropertiesMessages[property]
  }
}
